import { render, staticRenderFns } from "./PureContactBalanceAndTransactions.vue?vue&type=template&id=2fea6f80&"
import script from "./PureContactBalanceAndTransactions.vue?vue&type=script&lang=js&"
export * from "./PureContactBalanceAndTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports